// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"92d6df5d","977":"fff7f774"}[chunkId] + ".chunk.js";
};